<template>
  <div v-if="page">
    <h2>{{ $t("wallet.withdraw") }}</h2>
    <div v-if="page.withdrawGeneralMsg" class="row mb-3">
      <page-title :subheading="page.withdrawGeneralMsg.content"></page-title>
    </div>
    <token-list
      page="withdraw"
      :token-list="page.viewer.totals"
      :daily-loyalty="null"
    />
    <div class="withdraw-layout mb-3">
      <div class="withdraw-pair-row">
        <div class="withdraw-col">
          <div class="withdraw-col-inner">
            <template
              v-if="
                !page.viewer.totals.hasPendingWithdrawal &&
                !page.viewer.totals.hasPendingUsdtWithdrawal
              "
            >
              <div
                style="
                  margin-left: auto;
                  margin-right: auto;
                  margin-bottom: 10px;
                "
              >
                <h3>&nbsp;</h3>
              </div>
              <div style="text-align: center; margin-bottom: 15px">
                <img
                  src="@/assets/images/crypto/HTL.png"
                  style="width: 130px"
                />
              </div>
              <div class="withdraw-component-wrapper w-100">
                <withdraw-to-htl
                  class="col-12"
                  @update="update"
                  :maxHtl="withdrawalLimit(page.viewer)"
                  :maxUsd="withdrawalLimitUSDT(page.viewer)"
                  :kyc="page.viewer.hasKYC"
                />
              </div>
            </template>

            <div
              v-if="page.viewer.totals.hasPendingWithdrawal"
              class="withdraw-component-wrapper w-100"
            >
              <cancel-withdrawal class="col-12" @update="update" />
            </div>
          </div>
        </div>
        <div class="withdraw-col" v-if="page.viewer.nobtc === false">
          <div class="withdraw-col-inner">
            <template
              v-if="
                !page.viewer.totals.hasPendingWithdrawal &&
                !page.viewer.totals.hasPendingUsdtWithdrawal
              "
            >
              <div
                style="
                  margin-left: auto;
                  margin-right: auto;
                  margin-bottom: 10px;
                "
              >
                <h3>{{ $t("withdraw.temp") }}</h3>
              </div>

              <div style="text-align: center; margin-bottom: 15px">
                <img
                  src="@/assets/images/crypto/BTC-logo.png"
                  style="width: 130px"
                />
              </div>
              <div class="withdraw-component-wrapper w-100">
                <withdraw-to-btc
                  class="col-12"
                  @update="update"
                  :maxHtl="withdrawalLimit(page.viewer)"
                  :maxUsd="withdrawalLimitUSDT(page.viewer)"
                  :kyc="page.viewer.hasKYC"
                />
              </div>
            </template>

            <div
              v-if="page.viewer.totals.hasPendingUsdtWithdrawal"
              class="withdraw-component-wrapper w-100"
            >
              <cancel-usdt-withdrawal class="col-12" @update="update" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageTitle from "@/components/common/PageTitle";
import TokenList from "@/components/Dashboard/TokenList";
import WithdrawToHtl from "@/components/Wallet/WithdrawToHtl.vue";
import WithdrawToBtc from "@/components/Wallet/WithdrawToBtc.vue";
import CancelWithdrawal from "@/components/Wallet/CancelWithdrawal";
import CancelUsdtWithdrawal from "@/components/Wallet/CancelUsdtWithdrawal";
import gql from "graphql-tag";

export default {
  name: "Withdraw",
  components: {
    TokenList,
    PageTitle,
    WithdrawToHtl,
    WithdrawToBtc,
    CancelWithdrawal,
    CancelUsdtWithdrawal,
  },
  data() {
    return {
      page: null,
    };
  },
  methods: {
    update() {
      this.$apollo.queries.page.refetch();
    },
    btcWithdrawal(user) {
      const restricted = [
        "AF",
        "AU",
        "CN",
        "ET",
        "HK",
        "IQ",
        "IR",
        "KP",
        "LK",
        "PK",
        "SY",
        "TN",
        "UG",
        "US",
        "YE",
      ];
      return (
        restricted.includes(user.country) &&
        !user.isWithdrawalDisabled &&
        !user.totals.hasPendingWithdrawal
      );
    },
    withdrawalLimit(user) {
      return Math.min(user.withdrawalLimit, user.totals.tokens / 1e8);
    },
    withdrawalLimitBTC(user) {
      return Math.min(
        user.withdrawalLimit * this.htlBtc,
        user.totals.tokens / 1e8
      );
    },
    withdrawalLimitUSDT(user) {
      return Math.min(
        user.withdrawalLimit * this.htlUsd,
        user.totals.usdt / 1e8
      );
    },
    withdrawalLimitUSDT2X(user) {
      return Math.min(user.withdrawalLimit, user.totals.usdt / 1e8);
    },
    withdrawalLimitUSDT2BTC(user) {
      return Math.min(
        user.withdrawalLimit * this.htlUsd,
        user.totals.usdt / 1e8
      );
    },
  },
  computed: {
    ...mapGetters({
      htlBtc: "prices/htlBtc",
      htlUsd: "prices/htlUsd",
    }),
  },
  apollo: {
    page: {
      query: gql`
        query page {
          withdraw2BTC: doc(id: "withdraw-to-btc") {
            id
            content
            title
          }
          withdraw2HTL: doc(id: "withdraw-to-htl") {
            id
            content
            title
          }
          withdrawGeneralMsg: doc(id: "withdraw-general-message") {
            id
            content
            title
          }
          viewer {
            id
            hasKYC
            country
            totals {
              tokens
              usdt
              hasPendingWithdrawal
              hasPendingUsdtWithdrawal
            }
            withdrawalLimit(currency: "HTL")
            nobtc
          }
          isWithdrawalDisabled
          viewerIsAdmin
        }
      `,
      update: (data) => data,
      result({ data }) {
        if (data) {
          this.$store.commit("user/updateAvailable", {
            tokens: data.viewer.totals.tokens,
          });
          if (data.viewerIsAdmin) {
            this.$store.commit("user/setAdmin");
          }
        }
      },
    },
  },
};
</script>

<style scoped>
.withdraw-pair-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}
.withdraw-col {
  flex: 0 1 auto;
  min-width: 320px;
  max-width: 650px;
  box-sizing: border-box;
}
.withdraw-col-inner {
  display: flex;
  flex-direction: column;
}
.page-title-wrapper,
.withdraw-component-wrapper {
  width: 100%;
}

@media (max-width: 900px) {
  .withdraw-col {
    width: 100%;
    flex: 1 1 100%;
  }
}
</style>
